// The Color Theme catalogue. Ids match the `$color-themes` map in
// styles/_colorThemes.scss, which owns the actual colors — a theme is a class
// name here and a single accent variable there, nothing more.

export const COLOR_THEME_NONE = 'none';

export const COLOR_THEMES = [
  { id: COLOR_THEME_NONE, name: 'None' },
  { id: 'rose', name: 'Rose' },
  { id: 'ember', name: 'Ember' },
  { id: 'gold', name: 'Gold' },
  { id: 'moss', name: 'Moss' },
  { id: 'teal', name: 'Teal' },
  { id: 'ocean', name: 'Ocean' },
  { id: 'indigo', name: 'Indigo' },
  { id: 'violet', name: 'Violet' },
  { id: 'plum', name: 'Plum' },
  { id: 'slate', name: 'Slate' },
];

export const isValidColorTheme = (id) => COLOR_THEMES.some((colorTheme) => colorTheme.id === id);

// Both classes are needed: the derivation block is keyed off `.color-theme`, and
// the accent itself off `.color-theme--<id>`.
export const getColorThemeClass = (id) =>
  !id || id === COLOR_THEME_NONE ? '' : `color-theme color-theme--${id}`;
